export default function asideFactory(siteService, $aside, $q) {
    var obj = this;
    obj.asideInstance;

    // ASIDE - SIDENAV !
    obj.asideState = {
        open: false,
    };

    /**
     * [openAside description]
     * @param  {[type]} $event           [description]
     * @param  {[type]} position         [description]
     * @param  {[type]} backdrop         [description]
     * @param  {[type]} declinedBookings [description]
     * @param  {[type]} repeatedBooking  [description]
     * @return {[type]}                  [description]
     */
    obj.open = function (
        $event,
        position = "right",
        backdrop = true,
        declinedBookings = null,
        repeatedBooking = null
    ) {
        var template = "aside-left.html";

        if (
            siteService.asideState.open &&
            siteService.asideState.position == "right"
        ) {
            return false;
        }

        if (position == "right") {
            template = "aside-right.html";
        }

        obj.asideState = siteService.asideState = {
            open: true,
            position: position,
        };

        obj.asideInstance = $aside.open({
            template: require("./" + template),
            placement: position,
            size: "sm",
            controller: "asideController",
            backdrop: backdrop,
            openedClass: "modal-aside modal-open",
            resolve: {
                declinedBookings: function () {
                    //var someVar = someVar; // but nice to keep for later use

                    if (declinedBookings) {
                        return declinedBookings;
                    }
                },
                repeatedBooking: function () {
                    if (repeatedBooking) {
                        return repeatedBooking;
                    }
                },
            },
        });

        obj.asideInstance.result.then(
            function () {
                //avail param : selectedItem
                // $scope.selected = selectedItem;

                obj.asideState.open = siteService.asideState.open = false;
            },
            function () {
                obj.asideState.open = siteService.asideState.open = false;
                // console.info("modal-component dismissed at: " + new Date());
            }
        );
    };

    obj.close = function () {
        let deferred = $q.defer();
        let status = obj.asideInstance.close();

        if (status) {
            deferred.resolve(status);
        } else {
            deferred.reject("could not close aside right");
        }

        return deferred.promise;
    };

    return obj;
}
